import styled from 'styled-components';
import { ShortBody } from 'components/Typography';
import { Divider } from '@material-ui/core';

export const StyledCaptions = styled(ShortBody)`
  &&& {
    line-height: 23px;
    color: #0075c9;
    font-size: 18px;
  }
`;
export const StyledLigne = styled(ShortBody)`
  &&& {
    line-height: 22px;
    color: #162952;
    font-size: 13px;
  }
`;
export const ColoredDivider = styled(Divider)`
  && {
    background-color: #979797;
    opacity: 24%;
    margin-bottom: 20px;
  }
`;
